class App {
  constructor() {
    this.vars = window.statelyVars || {};
    this.module = this.vars?.page?.type || '';
    this.preview = Shopify.theme.role === 'unpublished' && Shopify.theme.name.indexOf('Test') !== 0;
    // Site debug mode lives in sm-track.js (loads before this bundle) as
    // window.smDebug: persistent per session via ?sdebug=1 / ?sdebug=0,
    // always on for preview themes. It also logs the "🪲 Debug mode active"
    // line, so only log here on the fallback path where sm-track.js didn't
    // load.
    const hasSmDebug = typeof window.smDebug === 'boolean';
    this.debug = hasSmDebug
      ? window.smDebug
      : this.preview || window.location.search.indexOf('sdebug=1') !== -1;
    if (this.debug && !hasSmDebug) {
      console.log('🪲 Debug mode active');
    }

    this.init();
  }

  init() {

    /*
    if (document.getElementById('quiz') || document.getElementById('plans')) {
      this.styleProfile = new StyleProfile();
    }

    if (this.module === 'customers' || this.module === 'account') {
      this.account = new Account();
    }

    if (this.module === 'products' || this.module === 'collections' || this.vars?.page?.suffix.indexOf('oob') !== -1) {
      this.store = new Store();
    }
    */

    this.initUTM();
    this.initAmbassadorFlow();
    // Chrome prerenders address-bar navigations, and a prerendered page runs
    // its JS against a throwaway CLONE of sessionStorage — writes made before
    // activation are silently discarded when the real page swaps in. Re-run
    // the URL-param captures once the page becomes the live one so markers
    // (utm_params, ambassador_flow) survive prerendered entries. Both are
    // idempotent, so the double-run on non-prerendered loads is harmless.
    if (document.prerendering) {
      document.addEventListener('prerenderingchange', () => {
        this.initUTM();
        this.initAmbassadorFlow();
      }, { once: true });
    }

    window.addEventListener('DOMContentLoaded', () => {
      this.initLoaded();
    });
  }

  initLoaded() {
    this.initMenuLinks();

    if (this.preview) {
      this.setPreviewDisplay();
    }

    if (this.vars?.page.type == 'cart') {
      this.getCart();
    }
  
    this.initDeviceType();

    this.initLogoutLinks();
  }

  initLogoutLinks() {
    // Clear email from quiz_data on logout
    const logoutLink = '/account/logout';
    document.querySelectorAll('a[href="' + logoutLink + '"]').forEach(link => {
      link.addEventListener('click', (e) => {
        e.preventDefault();
        const quizData = JSON.parse(localStorage.getItem('quiz_data'));
        if (quizData && quizData.email) {
          delete quizData.email;
          localStorage.setItem('quiz_data', JSON.stringify(quizData));
        }
        window.location.href = logoutLink;
      });
    });
  }
  
  initMenuLinks() {
    // Menu link new window format (link, width, height): https://example.com/123x456/
    // Menu link onclick format: /onclick/javascriptAction();
    document.querySelectorAll('.menu-link').forEach(link => {
      const onclick = link.href.indexOf('/onclick/') !== -1 ? link.href.split('/onclick/')[1] : null;
      if (onclick) {
        link.setAttribute('onclick', onclick);
        link.addEventListener('click', (e) => {
          e.preventDefault();
        });
      }
    });
  }

  setPreviewDisplay() {
    const theme = 'Theme preview: ' + Shopify.theme.name;
    // Hide Shopify's preview bar via a body-class flag rather than toggling the
    // bar element directly. Shopify injects the bar asynchronously (and under
    // more than one id: #PBarNextFrameWrapper or #preview-bar-iframe), so a
    // direct selector can miss it if the click lands before injection. The CSS
    // rule keyed on this class applies to whichever bar appears, whenever it
    // appears — clicking the box just clears the flag.
    document.body.classList.add('stately-hide-preview-bar');
    const div = document.createElement('div');
    div.textContent = theme;
    div.classList.add('theme-preview');
    div.addEventListener('click', () => {
      document.body.classList.remove('stately-hide-preview-bar');
      div.remove();
    });
    document.body.appendChild(div);
    console.log(theme);
  }

  newWindow(url, width, height) {
    const screenWidth = window.screen.availWidth;
    const screenHeight = window.screen.availHeight;
    width = typeof width !== 'undefined' ? width : Math.floor(screenWidth * 0.7);
    height = typeof height !== 'undefined' ? height : Math.floor(screenHeight * 0.7);
    const left = Math.max(Math.floor((screenWidth - width) / 2), 0);
    const top = Math.max(Math.floor((screenHeight - height) / 2), 0);

    const features = [
      `width=${width}`,
      `height=${height}`,
      `left=${left}`,
      `top=${top}`,
      'menubar=no',
      'toolbar=no',
      'location=no',
      'status=no',
      'resizable=yes',
      'scrollbars=no'
    ].join(',');

    window.open(url, 'target', features);
  }

  getCart() {
    return fetch('/cart.js', {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      }
    })
    .then(response => response.json())
    .then(cart => {
      console.log('🛒 ', cart);
    })
    .catch(error => {
      console.error('Error fetching cart:', error);
      return null;
    });
  }

  initDeviceType() {
    const ua = navigator.userAgent;
    const platform = navigator.platform;
    const isTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0;

    let os = 'unknown-os';
    let device = 'desktop';

    // --- Detect OS ---
    if (/win/i.test(platform)) {
      os = 'windows';
    } else if (/android/i.test(ua)) {
      os = 'android';
    } else if (/iPad|iPhone|iPod/.test(ua) && !window.MSStream) {
      os = 'ios';
    } else if (platform === 'MacIntel' && navigator.maxTouchPoints > 1) {
      // iPadOS 13+ pretends to be Mac
      os = 'ios';
    } else if (/mac/i.test(platform)) {
      os = 'mac';
    }

    if (/iPad/.test(ua) || (platform === 'MacIntel' && navigator.maxTouchPoints > 1)) {
      device = 'tablet';
    } else if (/android/i.test(ua) && /mobile/i.test(ua)) {
      device = 'mobile';
    } else if (/android/i.test(ua)) {
      device = 'tablet';
    } else if (/iPhone|iPod/i.test(ua)) {
      device = 'mobile';
    } else if (isTouch && window.innerWidth < 768) {
      device = 'mobile';
    } else if (isTouch) {
      device = 'tablet';
    }

    document.body.classList.add(os, device);
  }

  initUTM() {
    // Get UTM paramaters from URL and add to session storage
    const urlParams = new URLSearchParams(window.location.search);
    const utmParams = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'];
    let utmData = {};

    utmParams.forEach(param => {
      const value = urlParams.get(param);
      if (value) {
        utmData[param.replace('utm_', '')] = value;
      }
    });

    if (Object.keys(utmData).length > 0) {
      sessionStorage.setItem('utm_params', JSON.stringify(utmData));
    }
  }

  // Ambassador / influencer routing markers. Flows are configured in Theme
  // settings → Ambassador Flow and exposed on every page via
  // statelyVars.ambassador.flows (theme.liquid) — the single source of truth
  // shared with the quiz routing (style-profile.js) and the standard plans
  // page redirect (plans.js).
  //
  // A param is captured for the session only when the visitor is ON that
  // flow's designated Entry Page (e.g. the ambassador portal). Params on
  // other pages are ignored here — but the quiz and plans consumers also
  // check their own live URL, so an explicit ?r=1 directly on those pages
  // still counts without being persisted.
  //
  // The entry-page param IS the ambassador's level, and they have exactly one:
  // the sanctioned flow is an entry-page link (?r=1 / ?p=1) → CTA → quiz →
  // their level's plans page, with the param never carried past the entry page.
  // Changing someone's level means sending a fresh entry-page link with the new
  // param, which is why the write below REPLACES rather than merges.
  initAmbassadorFlow() {
    const flows = (this.vars.ambassador && this.vars.ambassador.flows) || [];
    if (!flows.length) return;

    const urlParams = new URLSearchParams(window.location.search);
    const normalizePath = (p) => String(p || '').toLowerCase().replace(/\/+$/, '') || '/';
    const currentPath = normalizePath(window.location.pathname);

    for (const flow of flows) {
      if (!flow.param || !flow.entry) continue;
      if (normalizePath(flow.entry) !== currentPath) continue;
      // Strict match: only the exact value "1" (what Superfiliate sends)
      // activates a flow. A looser truthy check would let unrelated URLs
      // (e.g. a `?p=2` pagination link) bucket normal visitors as ambassadors.
      if (urlParams.get(flow.param) !== '1') continue;

      // One level per ambassador, so this is a whole-value replace and the
      // previous marker is deliberately not read. Merging into the stored bag
      // (what this used to do) left the old param behind, and the consumers'
      // flow-order lookup found it first — so a visitor re-entering with ?p=1
      // after an earlier ?r=1 stayed on regal for the rest of the session, with
      // nothing to show anything had gone wrong. Keeping the bag single-keyed
      // also means flow order never has to arbitrate between two markers.
      //
      // Key name is shared with style-profile/ambassador-flow.js
      // (AMBASSADOR_STORAGE_KEY) — kept as a literal rather than imported so a
      // style-profile module isn't pulled into the core bundle. Change both.
      try {
        sessionStorage.setItem('ambassador_flow', JSON.stringify({ [flow.param]: '1' }));
      } catch (e) {
        // sessionStorage unavailable (private mode/quota); non-fatal.
      }
      // First configured flow wins if an entry URL somehow carries both params.
      return;
    }
  }
}

window.stately = window.stately || {};
window.stately.app = new App();
